import useAuthStore from '../store/authStore';

export const PRIVILEGES = {
    // Common
    DASHBOARD_VIEW: "DASHBOARD_VIEW",
    VIEW_HTML: "VIEW_HTML",

    // User Management
    VIEW_USERS: "VIEW_USERS",
    DELETE_USERS: "DELETE_USERS",
    RANK_CHANGE: "RANK_CHANGE",
    TEMP_USERS_VIEW: "TEMP_USERS_VIEW",
    TEMP_USERS_CREATE: "TEMP_USERS_CREATE",
    NEW_REGISTERED_USERS: "NEW_REGISTERED_USERS",

    // Rank Management
    ADD_NEW_RANKS: "ADD_NEW_RANKS",
    DELETE_RANKS: "DELETE_RANKS",
    VIEW_RANKS: "VIEW_RANKS",
    EDIT_RANKS: "EDIT_RANKS",
    RANK_PRIVILEGES_VIEW: "RANK_PRIVILEGES_VIEW",
    RANK_PRIVILEGES_EDIT: "RANK_PRIVILEGES_EDIT",
    
    // Privilege Management
    ADD_NEW_PRIVILEGES: "ADD_NEW_PRIVILEGES",
    DELETE_PRIVILEGES: "DELETE_PRIVILEGES",
    EDIT_PRIVILEGES: "EDIT_PRIVILEGES",
    VIEW_PRIVILEGES: "VIEW_PRIVILEGES",
    VIEW_INST_PRIVILEGES: "VIEW_INST_PRIVILEGES",
    EDIT_INST_PRIVILEGES: "EDIT_INST_PRIVILEGES",

    // Questions
    ADD_NEW_QUESTION: "ADD_NEW_QUESTION",
    UPLOAD_QUESTION_EXCEL: "UPLOAD_QUESTION_EXCEL",
    ADD_NEW_HIERARCHY: "ADD_NEW_HIERARCHY",
    EDIT_QUESTION_VIEW: "EDIT_QUESTION_VIEW",
    DOWNLOAD_QUESTION: "DOWNLOAD_QUESTION",
    DELETE_ACTIVATE_QUESTION: "DELETE_ACTIVATE_QUESTION",
    MOVE_QUESTION: "MOVE_QUESTION",
    UPDATE_QUESTION: "UPDATE_QUESTION",
    ADMIN_TEST_ANALYTICS_VIEW: "ADMIN_TEST_ANALYTICS_VIEW",

    // Question Bank
    EDIT_QB_QUESTIONS: "EDIT_QB_QUESTIONS",
    DELETE_QB_QUESTIONS: "DELETE_QB_QUESTIONS",
    UPLOAD_QB_QUESTIONS: "UPLOAD_QB_QUESTIONS",
    VIEW_QB_QUESTIONS: "VIEW_QB_QUESTIONS",

    // Tests
    CREATE_TEST: "CREATE_TEST",
    PRACTICE_TEST: "PRACTICE_TEST",
    EVALUATION_TEST: "EVALUATION_TEST",
    MOCK_TEST: "MOCK_TEST",
    COMPETITION_TEST: "COMPETITION_TEST",
    OVERALL_ADMIN_TEST_ANALYTICS_VIEW: "OVERALL_ADMIN_TEST_ANALYTICS_VIEW",

    // Analysis
    OVERALL_ANALYSIS_VIEW: "OVERALL_ANALYSIS_VIEW",
    SUBJECT_ANALYSIS_VIEW: "SUBJECT_ANALYSIS_VIEW",
    USER_ANALYSIS_VIEW: "USER_ANALYSIS_VIEW",

    // Learning Pathway
    VIEW_CONTENT_LP: "VIEW_CONTENT_LP",
    ADD_CONTENT_LP: "ADD_CONTENT_LP",
    ADD_TEXT_CONTENT_LP: "ADD_TEXT_CONTENT_LP",
    ADD_VIDEO_CONTENT_LP: "ADD_VIDEO_CONTENT_LP",
    ADD_PDF_CONTENT_LP: "ADD_PDF_CONTENT_LP",
    ADD_AUDIO_CONTENT_LP: "ADD_AUDIO_CONTENT_LP",
    ADD_TEST_CONTENT_LP: "ADD_TEST_CONTENT_LP",
    EDIT_CONTENT_LP: "EDIT_CONTENT_LP",
    DELETE_CONTENT_LP: "DELETE_CONTENT_LP",

    // Institution Management
    ADD_NEW_INST: "ADD_NEW_INST",
    EDIT_INST: "EDIT_INST",
    DELETE_INST: "DELETE_INST",
    VIEW_INST: "VIEW_INST",

    // Ad Management
    ADD_NEW_ADS: "ADD_NEW_ADS",
    EDIT_ADS: "EDIT_ADS",
    PREVIEW_ADS: "PREVIEW_ADS",
    VIEW_ADS: "VIEW_ADS",
    CHANGE_ADS_STATUS: "CHANGE_ADS_STATUS",

    // Configuration
    VIEW_CONFIGURATIONS: "VIEW_CONFIGURATIONS",
    REPLACE_COLOR: "REPLACE_COLOR",
    DELETE_COLORS: "DELETE_COLORS",
    EDIT_COLORS: "EDIT_COLORS",
    UPLOAD_COLORS: "UPLOAD_COLORS",
    VIEW_COLORS: "VIEW_COLORS",
    APP_COLOR: "APP_COLOR",
    WEBAPP_COLOR: "WEBAPP_COLOR",
    ADMIN_COLOR: "ADMIN_COLOR",

    // Product Management
    VIEW_PRODUCT: "VIEW_PRODUCT",
    CHANGE_PRODUCT_STATUS: "CHANGE_PRODUCT_STATUS",
    ADD_NEW_PRODUCT: "ADD_NEW_PRODUCT",
    EDIT_PRODUCT: "EDIT_PRODUCT",

    // Order Management
    CHANGE_ORDER_SHIPPINGSTATUS: "CHANGE_ORDER_SHIPPINGSTATUS",
    DETAIL_VIEW_ORDER: "DETAIL_VIEW_ORDER",
    VIEW_ORDER: "VIEW_ORDER",

    // Mock Test Management
    EDIT_MOCKTEST: "EDIT_MOCKTEST",
    VIEW_MOCKTEST: "VIEW_MOCKTEST",

    // Students Management
    VIEW_REGISTRATION_STUDENT: "VIEW_REGISTRATION_STUDENT",
    DELETE_REGISTRATION_STUDENT: "DELETE_REGISTRATION_STUDENT",

    // Notifications & Quartz Schedules
    VIEW_NOTIFICATIONS: "VIEW_NOTIFICATIONS",
    CREATE_NOTIFICATION: "CREATE_NOTIFICATION",
    EDIT_NOTIFICATION: "EDIT_NOTIFICATION",
    DELETE_NOTIFICATION: "DELETE_NOTIFICATION",
};

export const usePrivileges = () => {
    const { privileges, institution } = useAuthStore();

    /**
     * Checks if the user has a specific privilege
     * @param {string} privilegeCode 
     * @returns {boolean}
     */
    const hasPrivilege = (privilegeCode) => privileges?.includes(privilegeCode);

    return {
        hasPrivilege,
        privileges,
        institution,
        codes: PRIVILEGES
    };
};
